module.exports = __webpack_public_path__ + "img/1-4.ff43be94.svg";